<div class="row align-items-center">

  <div class="col-auto activity-avatar-column">
    <div class="activity-avatar" [class.has-icon]="icon">
      <sc-avatar [user]="user" size="md"></sc-avatar>
      @if (icon) {
        <span class="activity-icon bg-primary-lighter">
          <ng-content select="[scActivityIcon]"></ng-content>
        </span>
      }
    </div>
  </div>

  <div class="col col-shrink">
    <div class="activity-headline mb-n1">
      <sc-avatar class="activity-headline-avatar" [user]="user" size="xs"></sc-avatar>
      <span class="fw-bold"><ng-content select="[scActivityPrefix]"></ng-content> @if (!hideUserName) { {{ userName }} } <ng-content></ng-content></span>
    </div>
    @if (!condensed) {
      <div class="small fw-normal activity-body mt-1">
        <ng-content select="[scActivityBody]"></ng-content>
      </div>
    }
    <div class="small text-muted fw-normal">
      @if (humanizeDate) {
        <span title="{{ activity?.Timestamp | date : 'dd.MM.yyyy' }} um {{ activity?.Timestamp | date : 'HH:mm' }} Uhr">{{ activity?.Timestamp | humanizedDate }}</span>
      } @else {
        am {{ activity?.Timestamp | date : 'dd.MM.yy' }} um {{ activity?.Timestamp | date : 'HH:mm' }} Uhr
      }
      @if (showProjectName && activity?.Project) {
        in <a [routerLink]="['/projects', activity.Project.Id]">{{ activity.Project.Name }} m|w|d</a>
      }
    </div>
  </div>

  @if (link) {
    <div class="col-auto text-muted ps-0">
      <a class="stretched-link text-muted" [routerLink]="link"><i class="fa-regular fa-chevron-right"></i></a>
    </div>
  }

</div>
